import { locale, util } from '@glu/core';
import dialog from '@glu/dialog';
import { FlexDropdownItemView } from '@glu/flex-dropdown';

import template from './dropdownItemView.hbs';

export default FlexDropdownItemView.extend({
  template,

  collectionEvents: {
    'change:default': 'render'
  },

  initialize(options) {
    this.collection = (options || {}).savedViewsCollection;
  },

  getModel() {
    // this is necessary since flexDropdown works with a separate collection
    return this.collection.findWhere({
      id: this.model.get('id')
    });
  },

  events(...args) {
    const events = FlexDropdownItemView.prototype.events.apply(this, args);

    return util.extend(events, {
      'click .grid-saved-views-remove': 'handleSavedViewRemove',
      'click .grid-save-view-make-default': 'makeSavedViewDefault'
    });
  },

  className(...args) {
    let className = FlexDropdownItemView.prototype.className.apply(this, args);

    className += ' row';

    if (this.model.get('notVisibleItem')) {
      className += ' hidden';
    }

    return className;
  },

  templateHelpers(...args) {
    const helpers = FlexDropdownItemView.prototype.templateHelpers.apply(this, args);
    const model = this.getModel();

    return util.extend(helpers, {
      isDefault: model && model.get('default')
    });
  },

  handleSavedViewRemove(e) {
    e.preventDefault();
    e.stopPropagation();

    this.showDialog('removeSavedView', 'removeSavedViewMsg', this.removeSavedView);
  },

  makeSavedViewDefault(e) {
    e.preventDefault();

    this.makeDefaultSavedView();
  },

  showDialog(title, message, handler) {
    handler = handler || (() => {});

    dialog.confirm(locale.get(message, this.model.get('name')), locale.get(title), (ok) => {
      if (ok) {
        handler.call(this);
      }
    });
  },

  removeSavedView() {
    const model = this.getModel();
    if (model) {
      // remove from flex dropdown collection
      this.model.collection.remove(this.model);
      // remove from views collection
      this.collection.remove(model);
    }
  },

  makeDefaultSavedView() {
    const model = this.getModel();
    if (model) {
      model.set({
        default: true
      });
    }
  }
});
